module.exports = __webpack_public_path__ + "img/ni.8e43497b.svg";